import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Image, Row, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { serverApi } from "../../../../config/Keys";
import axios from "axios";
import isEmpty from "../../../../store/validation/is-Empty";
import moment from "moment";
import { useHistory } from "react-router";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

const EventsReportsDetails = () => {
  const history = useHistory();
  let id = history.location.pathname.split("/");
  id = id[id.length - 1];
  const [eventData, setEventData] = useState(null);
  const [eventUser, setEventUser] = useState([]);
  const [eventReport, setEventReport] = useState(null);
  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user.accessToken : "";
  });

  const getData = async () => {
    let eventData = await axios.get(
      `${serverApi}/event/reports/606d8819f610e10c6615a6cf`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    setEventData(eventData.data.event);
    setEventUser(eventData.data.users);
    setEventReport(eventData.data.report);
  };
  useEffect(() => {
    getData(id);
  }, [token]);

  return (
    <React.Fragment>
      {eventData ? (
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={2} />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation />
              <Row>
                <Col lg={4} className="pr-lg-0">
                  <Col className="pt-4 pb-3">
                    <NavLink
                      to="/reportdashboard"
                      className="f12-500 enBackLink"
                    >
                      <Image
                        fluid
                        alt="Back Icon"
                        title="Back Icon"
                        className="mr-2"
                        src={require("../../../../assets/images/UserManagement/backIcon.svg")}
                      />
                      Back
                    </NavLink>
                    <div className="f24_700_HelveticaNeue">
                      {`Event- ${eventData.restaurant_id.restaurant_name}`}
                    </div>
                    <div className="enRestaurantBox mt-3">
                      <div
                        className="enlogo"
                        style={{
                          backgroundImage: `url("${eventData.photos[0]}")`,
                        }}
                      >
                        <div className="enRElogo">
                          <Image
                            src={eventData.restaurant_id.logo_url}
                            alt="Profile pic"
                            title="Profile Pic"
                            fluid
                          />
                        </div>
                      </div>
                      <div className="enContent">
                        <div className="d-flex align-items-center">
                          <div className="f14-700">{eventData.name}</div>
                          <div
                            className={`${
                              eventData.isOnline
                                ? "enSuccessLBLSmall"
                                : "enPendingLBLSmall"
                            } ml-2`}
                          >
                            {eventData?.isOnline ? "Online" : "Offline"}
                          </div>
                        </div>
                        <div className="f11-400 text-gray mt-4">
                          {eventData.description}
                        </div>
                        <div className="d-flex flex-wrap mt-5">
                          <div className="d-flex align-items-start pr-3">
                            <Image
                              src={require("../../../../assets/images/UserManagement/calendar-red.svg")}
                              alt="Profile pic"
                              title="Profile Pic"
                              width="17px"
                            />
                            <div className="pl-3">
                              <div className="f9-400 text-gray">Dates</div>
                              <div className="f12-500">
                                {moment(eventData?.start_date).format("ll")}
                              </div>
                              <div className="f12-500">
                                - {moment(eventData?.end_date).format("ll")}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-start pl-3">
                            <Image
                              src={require("../../../../assets/images/UserManagement/clock-red.svg")}
                              alt="Profile pic"
                              title="Profile Pic"
                              width="17px"
                            />
                            <div className="pl-3">
                              <div className="f9-400 text-gray">Time</div>
                              <div className="f12-500">05:00 PM -</div>
                              <div className="f12-500">10:00 PM</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
                <Col lg={8} className="enBgGray enMinHeight100vh">
                  <div className="f14-500 opacity5 my-5">
                    {`Event ID - ${eventData.event_id}`}
                  </div>
                  <div className="user-table-reusable-superadmin table-responsive">
                    <Table className="HideShowTable enMinWidth500">
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th className="f11-500" style={{ width: "20%" }}>
                            User Name
                          </th>
                          <th className="f11-500" style={{ width: "10%" }}>
                            Event
                            <br />
                            Viewed
                          </th>
                          <th className="f11-500" style={{ width: "15%" }}>
                            Viewed
                            <br />
                            Date -Time
                          </th>
                          <th className="f11-500" style={{ width: "10%" }}>
                            Coupon
                            <br />
                            Used
                          </th>
                          <th className="f11-500" style={{ width: "13%" }}>
                            Used
                            <br />
                            Date -Time
                          </th>
                          <th className="f11-500" style={{ width: "12%" }}>
                            Live stream
                            <br />
                            Viewed
                          </th>
                          <th className="f11-500" style={{ width: "20%" }}>
                            Viewed
                            <br />
                            Date -Time
                          </th>
                        </tr>
                      </thead>
                      {eventUser &&
                        eventUser.map((user) => (
                          <tbody>
                            <tr className="enUserFavoritesTableBody">
                              <td
                                style={{ width: "20%" }}
                                className="d-flex align-items-start"
                              >
                                <div className="d-flex flex-column align-items-center">
                                  <div className="enIMG33 rounded-circle">
                                    <Image
                                      src={
                                        user.user_id.profile_photo[0] ||
                                        require("../../../../assets/images/ActionImages/demoprofile.jpg")
                                      }
                                      alt="Profile pic"
                                      title="Profile Pic"
                                      className="h-100 w-100"
                                      fluid
                                    />
                                  </div>
                                  <div className="f10-400 pt-2">
                                    {user.user_details.name}
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                <div className="f10-500">
                                  {user.event_viewed || "-"}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="f10-500">
                                  {moment(user.event_viewed_time).format("ll")}
                                </div>
                                <div className="f10-400">
                                  {moment(user.event_viewed_time).format(
                                    "hh:mm A"
                                  )}
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                <div className="f10-500">
                                  {user.event_viewed || "-"}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="f10-500">
                                  {moment(user.event_viewed_time).format("ll")}
                                </div>
                                <div className="f10-400">
                                  {moment(user.event_viewed_time).format(
                                    "hh:mm A"
                                  )}
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                <div className="f10-500">
                                  {user.live_stream_viewed || "-"}
                                </div>
                              </td>
                              <td style={{ width: "20%" }}>
                                <div className="f10-500">
                                  {moment(user.live_stream_viewed_time).format(
                                    "ll"
                                  )}
                                </div>
                                <div className="f10-400">
                                  {moment(user.live_stream_viewed_time).format(
                                    "hh:mm A"
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      ) : (
        <AmealioLoader />
      )}
    </React.Fragment>
  );
};

export default EventsReportsDetails;
